import React, { useEffect, useState } from 'react';
import { paymentAPI } from '../../../../services/paymentAPI';
import { melhorEnvioAPI } from '../../Handlers/melhorEnvio';
import OrderCard from './OrderCardAdmin';

// Mapeamento de tradução e cores para os status
const STATUS_MAP = {
    pending: { label: 'Pendente', color: '#f39c12' },
    paid: { label: 'Pago', color: '#27ae60' },
    shipped: { label: 'Despachado', color: '#2980b9' },
    // Caso existam outros, você pode adicionar aqui:
    canceled: { label: 'Cancelado', color: '#e74c3c' }
};

function OrderPageAdmin() {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [btnLoading, setBtnLoading] = useState(false);

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const res = await paymentAPI.order_admin();
                setOrders(res?.data || res || []);
            } catch (error) {
                console.error("Erro:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchOrders();
    }, []);

    const handleGerarEtiqueta = async (orderId) => {
        setBtnLoading(true);
        try {
            const response = await melhorEnvioAPI.gerarEtiqueta(orderId);
            console.log("Resposta do Melhor Envio:", response);
            alert("Enviado ao Carrinho do Melhor Envio!");
        } catch (error) {
            console.error("Erro detalhado:", error.response?.data);
            alert("Erro ao despachar. Veja os detalhes no console do desenvolvedor.");
        } finally {
            setBtnLoading(false);
        }
    };

    // Função auxiliar para pegar o texto traduzido
    const getStatusInfo = (status) => {
        return STATUS_MAP[status.toLowerCase()] || { label: status, color: '#444' };
    };

    return (
        <div style={{ padding: '30px', maxWidth: '800px', margin: '0 auto', fontFamily: 'sans-serif' }}>
            <h2 style={{ letterSpacing: '-0.02em', color: '#1d1d1f' }}>Painel de Controle de Vendas</h2>

            {loading ? <p>Carregando...</p> : (
                orders.map(order => (
                    <OrderCard key={order.order_id} order={order} onOpenDetails={setSelectedOrder} />
                ))
            )}

            {selectedOrder && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
                    <div style={{ backgroundColor: 'white', padding: '25px', borderRadius: '12px', width: '95%', maxWidth: '450px', maxHeight: '90vh', overflowY: 'auto' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                            <h3 style={{ margin: 0 }}>Pedido #{selectedOrder.order_id}</h3>
                            <button onClick={() => setSelectedOrder(null)} style={{ border: 'none', background: 'none', fontSize: '24px', cursor: 'pointer', color: '#888' }}>&times;</button>
                        </div>

                        <div style={{ fontSize: '14px', color: '#444', borderBottom: '1px solid #eee', paddingBottom: '15px' }}>
                            <p>
                                <strong>Status: </strong> 
                                <span style={{ 
                                    color: 'white', 
                                    backgroundColor: getStatusInfo(selectedOrder.status).color,
                                    padding: '2px 8px',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                }}>
                                    {getStatusInfo(selectedOrder.status).label.toUpperCase()}
                                </span>
                            </p>

                            <p><strong>CPF:</strong> {selectedOrder.address?.cpf || selectedOrder.cpf || "Não informado"}</p>
                            <p><strong>Frete Escolhido:</strong> {selectedOrder.address?.frete?.name || "Não informado"}</p>
                            <p><strong>Destinatário:</strong> {selectedOrder.address?.nome || selectedOrder.address?.name || "Não informado"}</p>
                            <p><strong>Endereço:</strong> {selectedOrder.address?.street}, {selectedOrder.address?.number}</p>
                            <p><strong>Bairro:</strong> {selectedOrder.address?.neighborhood} - <strong>CEP:</strong> {selectedOrder.address?.cep}</p>
                            <p><strong>Telefone:</strong> {selectedOrder.address?.telefone || "Não informado"}</p>
                        </div>

                        {/* Só mostra o botão de despachar se o status for "paid" (pago) */}
                        <div style={{ margin: '15px 0' }}>
                            <button
                                onClick={() => handleGerarEtiqueta(selectedOrder.order_id)}
                                disabled={btnLoading || selectedOrder.status !== 'paid'}
                                style={{ 
                                    width: '100%', 
                                    padding: '12px', 
                                    backgroundColor: selectedOrder.status === 'paid' ? '#307195' : '#ccc', 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: '6px', 
                                    cursor: selectedOrder.status === 'paid' ? 'pointer' : 'not-allowed', 
                                    fontWeight: 'bold' 
                                }}
                            >
                                {btnLoading ? "Enviando..." : "🚚 DESPACHAR NO MELHOR ENVIO"}
                            </button>
                            {selectedOrder.status === 'shipped' && (
                                <p style={{ fontSize: '12px', color: '#27ae60', textAlign: 'center', marginTop: '5px' }}>Este pedido já foi despachado.</p>
                            )}
                        </div>

                        <h4 style={{ margin: '15px 0 10px 0' }}>Itens:</h4>
                        <div style={{ maxHeight: '150px', overflowY: 'auto', backgroundColor: '#f9f9f9', padding: '10px', borderRadius: '8px' }}>
                            {selectedOrder.items?.map((item, idx) => (
                                <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0', borderBottom: '1px solid #eee' }}>
                                    <span>{item.quantity}x {item.product_name}</span>
                                    <strong>R$ {item.price.toFixed(2)}</strong>
                                </div>
                            ))}
                        </div>

                        <div style={{ marginTop: '15px', textAlign: 'right', fontSize: '18px', fontWeight: 'bold' }}>
                            Total: R$ {selectedOrder.total.toFixed(2)}
                        </div>

                        <button onClick={() => setSelectedOrder(null)} style={{ marginTop: '20px', width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '6px', cursor: 'pointer', background: '#fff' }}>Fechar</button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default OrderPageAdmin;